import { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Grid, Typography } from "@mui/material";

import CustomLoadingOverlay from "../../../Components/CustomLoadingOverlay";

import { getColumns } from "./columns";
import StatusChangeConfirmationModal from "./StatusChangeConfirmationModal";
import MasterSettingModal from "./MasterSettingModal";
import { useMasterSetting } from "../../../Hooks/useMasterSetting";

export default function MasterSetting() {
  const [selectedSetting, setSelectedSetting] = useState(null);
  const [changingStatus, setChangingStatus] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });
  const [sortModel, setSortModel] = useState([]);
  const [openStatusChangeModal, setOpenStatusChangeModal] = useState(false);
  const [openSettingModal, setOpenSettingModal] = useState(false);

  const {
    masterSettings,
    timeList,
    loading,
    rowCount,
    refreshMasterSettings,
    changeStatus,
  } = useMasterSetting({
    pagination: paginationModel,
    sorting: sortModel,
  });

  const handleChangeStatus = async () => {
    setChangingStatus(true);
    const newStatus = selectedSetting.status === 1 ? 0 : 1;

    const result = await changeStatus(selectedSetting.id, newStatus);

    if (result.success) {
      setSelectedSetting(null);
      setOpenStatusChangeModal(false);
    }
    setChangingStatus(false);
  };

  const handleOpenEditModal = (setting) => {
    setSelectedSetting(setting);
    setOpenSettingModal(true);
  };

  const handleCloseModal = () => {
    setOpenSettingModal(false);
    setSelectedSetting(null);
  };

  const handleSortModelChange = (newSortModel) => {
    setSortModel(newSortModel);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const columns = getColumns(
    setSelectedSetting,
    setOpenStatusChangeModal,
    handleOpenEditModal
  );

  return (
    <Box sx={{ width: "100%", padding: 2 }}>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          backgroundColor: "#fff",
          padding: "24px 16px",
          borderRadius: "8px",
        }}
      >
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="flex-end"
          mb={2}
        >
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Master Settings
            </Typography>
          </Grid>
        </Grid>

        <DataGrid
          rows={masterSettings || []}
          columns={columns}
          autoHeight
          disableRowSelectionOnClick
          loading={loading}
          slots={{
            loadingOverlay: CustomLoadingOverlay,
          }}
          sx={{
            "& .MuiDataGrid-cell": {
              fontSize: "14px",
              fontWeight: 500,
              color: "#48505E",
            },
          }}
          paginationMode="server"
          sortingMode="server"
          onSortModelChange={handleSortModelChange}
          sortModel={sortModel}
          rowCount={rowCount}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[20, 50, 100]}
        />

        {openStatusChangeModal && (
          <StatusChangeConfirmationModal
            open={openStatusChangeModal}
            cancel={() => setOpenStatusChangeModal(false)}
            title="Change Status"
            item={selectedSetting?.setting_name}
            loading={changingStatus}
            handleChangeStatus={handleChangeStatus}
          />
        )}

        {openSettingModal && (
          <MasterSettingModal
            open={openSettingModal}
            onClose={handleCloseModal}
            settingData={selectedSetting}
            timeList={timeList}
            onSuccess={refreshMasterSettings}
          />
        )}
      </Box>
    </Box>
  );
}
